import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../IndividualPlan/tokens';

export const NotableFindingsBlock = styled(Box)({
  marginTop: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const NotableFindingsHeader = styled(Box)({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: 16,
  flexWrap: 'wrap',
});

export const NotableFindingsTitle = styled('p')({
  margin: 0,
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  textTransform: 'capitalize',
  color: COLORS.muted,
});

export const NotableFindingsCaption = styled('p')({
  margin: 0,
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '24px',
  color: COLORS.muted,
});
